import { useMemo, useState } from "react";
import { Search, Check } from "lucide-react";
import { Input } from "../ui/input";
import { cn } from "../../lib/utils";
import { initials } from "../../lib/format";

// Liste cochable des élèves, avec recherche. `value` = tableau d'ids.
export function EleveMultiSelect({ eleves = [], value = [], onChange, maxHeight = 280 }) {
  const [q, setQ] = useState("");
  const selected = new Set(value);
  const filtered = useMemo(() => {
    const n = q.trim().toLowerCase();
    const list = n ? eleves.filter((e) => `${e.prenom} ${e.nom} ${e.email || ""}`.toLowerCase().includes(n)) : eleves;
    return [...list].sort((a, b) => (selected.has(b.id) - selected.has(a.id)) || a.nom.localeCompare(b.nom));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eleves, q]);

  const toggle = (id) => {
    const next = selected.has(id) ? value.filter((v) => v !== id) : [...value, id];
    onChange(next);
  };
  const allVisibleSelected = filtered.length > 0 && filtered.every((e) => selected.has(e.id));
  const toggleAll = () => {
    if (allVisibleSelected) onChange(value.filter((v) => !filtered.some((e) => e.id === v)));
    else onChange([...new Set([...value, ...filtered.map((e) => e.id)])]);
  };

  return (
    <div className="rounded-lg border border-border">
      <div className="flex items-center gap-2 border-b border-border p-2">
        <div className="relative flex-1">
          <Search size={15} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un élève..." className="pl-8 h-8" data-testid="eleve-multiselect-search" />
        </div>
        <button type="button" onClick={toggleAll} className="text-xs font-medium text-primary hover:underline whitespace-nowrap px-1">
          {allVisibleSelected ? "Tout décocher" : "Tout cocher"}
        </button>
      </div>
      <div className="overflow-y-auto p-1" style={{ maxHeight }}>
        {filtered.length === 0 && <p className="text-sm text-muted-foreground p-3 text-center">Aucun élève</p>}
        {filtered.map((e) => {
          const on = selected.has(e.id);
          return (
            <button
              type="button"
              key={e.id}
              onClick={() => toggle(e.id)}
              data-testid={`eleve-option-${e.id}`}
              className={cn("w-full flex items-center gap-3 rounded-md px-2 py-1.5 text-left text-sm hover:bg-accent", on && "bg-primary/5")}
            >
              <span className={cn("flex h-4 w-4 items-center justify-center rounded border shrink-0", on ? "bg-primary border-primary text-primary-foreground" : "border-input")}>
                {on && <Check size={12} strokeWidth={3} />}
              </span>
              <span className="h-7 w-7 shrink-0 rounded-full bg-muted text-[11px] font-semibold flex items-center justify-center">{initials(e.prenom, e.nom)}</span>
              <span className="truncate">{e.prenom} <span className="font-medium">{e.nom}</span></span>
            </button>
          );
        })}
      </div>
      <div className="border-t border-border px-3 py-1.5 text-xs text-muted-foreground">{value.length} élève{value.length > 1 ? "s" : ""} sélectionné{value.length > 1 ? "s" : ""}</div>
    </div>
  );
}
